import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { GoogleClass } from 'src/app/_models/googleClassroom/google-class';
import { ClassroomService } from 'src/app/_services/classroom.service';
import { ThrobberService } from 'src/app/_services/throbber.service';

@Component({
  selector: 'app-unidad-form-enlazar-classroom',
  standalone: false,
  templateUrl: './unidad-form-enlazar-classroom.component.html',
  styleUrls: ['./unidad-form-enlazar-classroom.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnidadFormEnlazarClassroomComponent implements OnInit {

  materias: any[];
  accion: boolean;
  materiasString: string;
  classroomSelectForm = new UntypedFormGroup({
    classroomSelect: new UntypedFormControl(null, Validators.required)
  });
  classrooms: GoogleClass[];

  constructor(
    public dialogRef: MatDialogRef<UnidadFormEnlazarClassroomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private classroomService: ClassroomService,
    private throbberService: ThrobberService,
    private snackBar: MatSnackBar,
    private customAlertService: CustomAlertService
  ) { }

  ngOnInit(): void {
    this.materias = this.data.materias;
    this.materiasString = this.materias.map(item => item.nombreCompleto).join(', ');
    this.accion = this.data.accion;
    this.classrooms = this.data.classrooms;
  }

  submit() {
    if (this.classroomSelectForm.valid) {
      const classroom = this.classrooms.find(item => item.id === this.classroomSelectForm.get('classroomSelect').value);
      if (classroom) {
        this.classroomService.enlazarClassroomMcp(this.materias, this.accion, classroom).subscribe(res => {
          this.dialogRef.close();
          this.throbberService.setThrobberState(false);
          this.snackBar.open('Se ha enlazado la materia al Google Course.');
        },
        err => {
          this.throbberService.setThrobberState(false);
          this.customAlertService.setCustomMessage({
            tipo: 'error',
            texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
          });
        });
      }
    } else {
      this.classroomSelectForm.markAllAsTouched();
    }
  }

}
